export const MaterialPlanBaseOfPlan = Object.freeze({
  BOM: 'BOM',
  PRODUCTION: 'PRODUCTION',
});

export const MaterialPlanStatus = Object.freeze({
  OPENED: 'O',
  CLOSED: 'C',
});

export const MaterialPlanStatusList = [
  { value: MaterialPlanStatus.OPENED, label: 'Nyitott' },
  { value: MaterialPlanStatus.CLOSED, label: 'Zárt' },
];

export const MaterialPlanStatusColors = Object.freeze({
  [MaterialPlanStatus.OPENED]: {
    rowClassName: '',
    backgroundColor: 'inherit',
    hoverBackgroundColor: 'inherit',
  },
  [MaterialPlanStatus.CLOSED]: {
    rowClassName: 'material-plan-status-closed',
    backgroundColor: 'rgba(34, 197, 94, 0.16)',
    hoverBackgroundColor: 'rgba(34, 197, 94, 0.24)',
  },
});

export const MaterialPlanBaseOfPlanList = [
  { value: MaterialPlanBaseOfPlan.BOM, label: 'Forrásjegyzék' },
  { value: MaterialPlanBaseOfPlan.PRODUCTION, label: 'Gyártás' },
];
